import React, { Component } from 'react';
import { Col, Card, CardBody, CardImg, Button } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Form, FormGroup, FormText, Label, Input, CustomInput } from 'reactstrap';

export class RenderProgramModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            fadeIn: false,

            buttonDisabled: true,
            contactInfoList: [],
            contactInfoId: 0,

            programDetails: {
                id: "", // render a random id
                src: "../img/no-program-src.png",
                altText: "",
                caption: "",
                header: "",
                longDescription: "",
                tags: [],
                trainingAreas: [],
                audience: [],
                clientRatio: [],
                operatingHours: [],
                QAQuestions: [
                    ["What is the price for this program?", "Our price varies depend on how many parts of program you would like to choose. Plese state the specific program in your contact email."],
                    ["Who should I contact if I would like to volunteer for this program?", "Please Email the contact for your corresponding location. We would direct you from there."]
                ],
                contact: {}, // name: [[phone, email], [phone, email]], name: [[phone, email]]
                organizer: "FCSN" //later change to current organization ID
            }
        };
        this.toggle = this.toggle.bind(this);
        this.onDismiss = this.onDismiss.bind(this);
    }

    // check wether submit button should be disabled
    checkDisable = () => {
        let numContactor = 0;
        let allContactorVaild = true;
        // logic: both name and description should be filled
        // need to have at least one contact info, and each contact info should have either email and phone
        this.state.contactInfoList.forEach(element => {
            if (element[2] && element[0] !== "") {
                numContactor = numContactor + 1;
            }
            if (element[2] && element[0] === "") {
                allContactorVaild = false;
            }
        });
        if (allContactorVaild && numContactor !== 0 && this.state.programDetails.header !== "" && this.state.programDetails.caption !== "") {
            this.setState(() => {
                return { buttonDisabled: false };
            })
        } else {
            this.setState(() => {
                return { buttonDisabled: true };
            })
        }
    }

    //  add a new contact information to state
    handleAddContact = () => {
        this.setState((prevState) => {
            let newContactInfo = [];
            newContactInfo[0] = ""; // contacter name
            newContactInfo[1] = ""; // contacter email
            newContactInfo[2] = true; // whether dispaly as the result
            newContactInfo[3] = prevState.contactInfoId; // each contact info id
            newContactInfo[4] = ""; // contacter phone
            let newContactInfoList = prevState.contactInfoList;
            newContactInfoList[prevState.contactInfoId] = newContactInfo;
            // update id 
            let newcontactInfoId = prevState.contactInfoId + 1;
            return { contactInfoId: newcontactInfoId, contactInfoList: newContactInfoList };
        }, this.checkDisable);
    }

    // remove specific contact information
    handleRemoveContact = (contactId) => {
        this.setState((prevState) => {
            let newContactInfoList = prevState.contactInfoList;
            newContactInfoList[contactId][2] = false;
            return { contactInfoList: newContactInfoList };
        }, this.checkDisable)
    }

    // add user name information to the contact info (located in the programDetails: contact)
    // need contact id(which contact card)  and new name 
    updateUsername = (contactId, newName) => {
        this.setState((prevState) => {
            let newContactInfoList = prevState.contactInfoList;
            newContactInfoList[contactId][0] = newName;
            return { contactInfoList: newContactInfoList };
        }, this.checkDisable)
    }


    // add email information to the contact info (located in the programDetails: contact)
    //  need to pass id(which contact card)  and new email as parameter
    updateContactInfoDetail = (contactId, detail) => {
        this.setState((prevState) => {
            let newContactInfoList = prevState.contactInfoList;
            newContactInfoList[contactId][1] = detail;
            return { contactInfoList: newContactInfoList };
        }, this.checkDisable)
    }

    // add email information to the contact info (located in the programDetails: contact)
    // need to pass contact id (which contact card) and new phone number as parameter
    updateContactPhone = (contactId, phone) => {
        this.setState((prevState) => {
            let newContactInfoList = prevState.contactInfoList;
            newContactInfoList[contactId][4] = phone;
            return { contactInfoList: newContactInfoList };
        }, this.checkDisable)
    }

    //  submit the all contact info and change it to the form in the database
    handleSubmitContactInfo = () => {
        let newContactDic = {};
        this.state.contactInfoList.forEach(contactInfo => {
            if (contactInfo[2]) {
                let contactor = contactInfo[0];
                let contactInfoDetail = contactInfo[1];
                let contactPhone = contactInfo[4];
                if (!(contactor in newContactDic)) {
                    let contactInfo = [];
                    let allInfoList = [];
                    contactInfo[0] = allInfoList;
                    allInfoList[0] = contactInfoDetail;
                    allInfoList[1] = contactPhone;
                    newContactDic[contactor] = contactInfo;
                } else {
                    let allInfoList = [];
                    allInfoList[0] = contactInfoDetail;
                    allInfoList[1] = contactPhone;
                    newContactDic[contactor][newContactDic[contactor].length] = allInfoList;
                }
            }
        });
        this.setState(Object.assign(this.state.programDetails, { contact: newContactDic }))
    }

    // toggle modal open & close
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal,
            fadeIn: false
        }));
    }

    onDismiss() {
        this.setState({ fadeIn: false });
    }

    // form submission
    programFormSubmit = () => {
        this.handleSubmitContactInfo();
        this.props.writeNewProgram(this.state.programDetails);

        // clear all data from the state
        this.setState(prevState => ({
            programDetails: {
                id: "",
                src: "../img/no-program-src.png",
                altText: "",
                caption: "",
                header: "",
                longDescription: "",
                tags: [],
                trainingAreas: [],
                audience: [],
                clientRatio: [],
                operatingHours: [],
                QAQuestions: [
                    [
                        "What is the price for this program?",
                        "Our price varies depend on how many parts of program you would like to choose. Plese state the specific program in your contact email."
                    ],
                    [
                        "Who should I contact if I would like to volunteer for this program?",
                        "Please Email the contact for your corresponding location. We would direct you from there."
                    ]
                ],
                contact: {},
                organizer: "FCSN"
            },
            modal: !prevState.modal,
            contactInfoList: [],
            contactInfoId: 0
        }));
    }




    render() {
        return (
            <Col sm="12" md="6" lg="4" className="mb-4">
                <Card className="h-100 justify-content-center bg-color-theme-5" width="100%" inverse onClick={this.toggle}>
                    <CardImg role="button" top width="100%" src="img/add-program-button.png" alt="add new program" />
                </Card>
                <Modal isOpen={this.state.modal} modalTransition={{ timeout: 200 }} backdropTransition={{ timeout: 300 }} toggle={this.toggle} className="modal-lg">
                    <ModalHeader toggle={this.toggle}>Form: New Program</ModalHeader>
                    <ModalBody>
                        <RenderForm data={this.props.data} programDetails={this.state.programDetails} checkDisable={this.checkDisable} />
                        <Contact
                            handleAddContact={this.handleAddContact}
                            handleRemoveContact={this.handleRemoveContact}
                            updateUsername={this.updateUsername}
                            updateContactInfoDetail={this.updateContactInfoDetail}
                            contactInfoList={this.state.contactInfoList}
                            updateContactPhone={this.updateContactPhone} />
                    </ModalBody>
                    <ModalFooter>
                        <Button disabled={this.state.buttonDisabled} color="primary" onClick={this.programFormSubmit}>Submit</Button>
                        <Button color="secondary" onClick={this.toggle}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </Col>
        );
    }
}


class Contact extends Component {
    render() {
        let contactInfoCardList = [];
        this.props.contactInfoList.forEach(singleContactInfo => {
            if (singleContactInfo[2]) {
                contactInfoCardList.push(<ContactInfoCard key={singleContactInfo[3]} contactId={singleContactInfo[3]}
                    handleDelet={this.props.handleRemoveContact} handleContactorNameChange={this.props.updateUsername}
                    handleContactInfoChange={this.props.updateContactInfoDetail} updateContactPhone={this.props.updateContactPhone} checkDisable={this.props.checkDisable} />);
            }
        });
        return <div>
            <p>Add new contact info: <span className="required">** Required **</span></p>
            <Button color="primary" onClick={this.props.handleAddContact} style={{ marginBottom: '1rem' }}>Add new contact info</Button>
            {contactInfoCardList}
        </div>
    }
}


class ContactInfoCard extends Component {
    constructor(props) {
        super(props);
        this.state = { contacterName: "", contactInfo: "", contactId: this.props.contactId, phone: "", vaild: true };
    }

    // track users name change in the input area
    handleUserNameChange = (event) => {
        let newContactorName = event.target.value;
        this.setState(() => {
            return { vaild: false };
        }, this.props.handleContactorNameChange(this.props.contactId, newContactorName));

    }
    // track email change in the input area
    handleUserContactChange = (event) => {
        let newContactorInfo = event.target.value;
        this.props.handleContactInfoChange(this.props.contactId, newContactorInfo);
    }

    // track phone change in the input area
    handleUserPhoneChange = (event) => {
        let newPhone = event.target.value;
        this.props.updateContactPhone(this.props.contactId, newPhone)

    }

    // delet contact info displayed
    handleDeletContactInfo = () => {
        this.props.handleDelet(this.state.contactId);
    }

    render() {
        return <Card className="contact_card">
            <CardBody>
                <Button close onClick={this.handleDeletContactInfo} />
                <FormGroup>
                    <Label for="Contact Info">Name <span className="required"> **This is required **</span> </Label>
                    <Input type="userName" name="userName" id="userName" placeholder="Type your contact name" onChange={this.handleUserNameChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="examplePassword">Email <span className="required"> **Email or Phone is required **</span> </Label>
                    <Input type="contactInfo" name="contactInfo" id="contactInfo" placeholder="Type your Email" onChange={this.handleUserContactChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="examplePassword">Phone Number <span className="required"> **Email or Phone is required **</span></Label>
                    <Input type="phone" name="phone" id="phone" placeholder="Type your phone" onChange={this.handleUserPhoneChange} />
                </FormGroup>
            </CardBody>
        </Card>
    }
}



export class RenderForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            optionalText: [],
        };
    }

    // change checkbox for tags
    onChange(checkbox) {
        let options = this.props.programDetails.tags;
        let index;
        if (checkbox.target.checked) {
            options.push(checkbox.target.value);
        } else {
            index = options.indexOf(checkbox.target.value);
            options.splice(index, 1);
        }
        options.sort();
        this.setState(Object.assign(this.props.programDetails, { tags: options }));
    }

    // toggle textarea
    toggleTextArea(event) {
        let options = this.state.optionalText;
        let index;
        if (event.target.checked) {
            options.push(event.target.value);
        } else {
            index = options.indexOf(event.target.value);
            options.splice(index, 1);
        }
        options.sort();
        this.setState({ optionalText: options });
        this.setState(Object.assign(this.props.programDetails, { [event.target.value]: [] }));
    }

    // event image
    addEventImage = (evt) => {
        let reader = new FileReader();
        if (evt.target.files[0]) {
            reader.readAsDataURL(evt.target.files[0]);
        }
        reader.onload = () => {
            this.setState(Object.assign(this.props.programDetails, { src: reader.result }))
        }
    }

    addQuestionToForm = () => {
        this.setState((currentState) => {
            currentState.questions.push(["", ""]);
            return currentState;
        })
    }

    render() {
        let checkBoxItems = ['Children', 'Teenager', 'Adult', 'Elders', 'Weekly', 'Monthly', 'Yearly', 'Living Skills', 'Social Service', 'Interests'];
        let checkboxes = checkBoxItems.map((label) => {
            return <CustomInput type="checkbox" id={label} key={label} label={label} value={label} checked={this.props.programDetails.tags.includes(label)} onChange={this.onChange.bind(this)} inline />
        });


        let additionalItems = [['Training Areas', 'trainingAreas', ''], ['Audience', 'audience', ''], ['Client Ratio', 'clientRatio', ''], ['Operating Hours', 'operatingHours', '']]
        let additional = additionalItems.map((label) => {
            let labelStatus = this.state.optionalText.includes(label[1]);
            let key = label[1] + 'key';
            if (labelStatus) {
                return <FormGroup key={key}><CustomInput type="checkbox" id={label[1]} key={label[1]} label={label[0]} value={label[1]} checked={labelStatus} onChange={this.toggleTextArea.bind(this)} /><Input type="textarea" name="text"
                    value={this.props.programDetails[label[1]]} placeholder="enter/return key will produce bullet points automatically" onChange={e => this.setState(Object.assign(this.props.programDetails, { [label[1]]: e.target.value }))} /></FormGroup>
            } else {
                return <CustomInput type="checkbox" id={label[1]} key={label[1]} label={label[0]} value={label[1]} checked={labelStatus} onChange={this.toggleTextArea.bind(this)} />
            }
        })

        return (
            <Form>
                <FormGroup>
                    <Label for="programName">Program Name<span className="required">** Required **</span></Label>
                    <Input name="programName" id="programName" placeholder="Please put complete program name (ex. Supported Living Services)" value={this.props.programDetails.altText}
                        onChange={name => this.setState(
                            Object.assign(this.props.programDetails, {
                                header: name.target.value,
                                altText: name.target.value,
                                id: name.target.value.replace(/\s+/g, '-').toLowerCase()
                            }), this.props.checkDisable())} />
                </FormGroup>
                <FormGroup>
                    <Label for="programDescription">Description<span className="required">** Required **</span></Label>
                    <Input type="textarea" name="programDescription" id="programDescription" placeholder="Less than 300 characters" value={this.props.programDetails.caption}
                        onChange={description => this.setState(
                            Object.assign(this.props.programDetails, {
                                caption: description.target.value
                            }), this.props.checkDisable())} />
                </FormGroup>
                <FormGroup>
                    <Label for="programLongDescription">Long Description (optional)</Label>
                    <Input type="textarea" name="programLongDescription" id="programLongDescription" placeholder="(optional)" value={this.props.programDetails.longDescription}
                        onChange={longDescription => this.setState(
                            Object.assign(this.props.programDetails, {
                                longDescription: longDescription.target.value
                            }))} />
                </FormGroup>
                <FormGroup>
                    <Label for="keywordsTag">Key Words</Label>
                    <div>
                        {checkboxes}
                    </div>
                </FormGroup>
                <FormGroup>
                    <Label for="programPhoto">Upload Program Profile Photo</Label>
                    <Input type="file" name="file" id="programPhoto" onChange={this.addEventImage} />
                    <FormText color="muted">Please note : higher resolution may be preferred for aesthetics!</FormText>
                </FormGroup>
                <FormGroup>
                    <FormGroup>
                        <Label for="exampleCheckbox">Other Desctiption (optional)</Label>
                        {additional}
                    </FormGroup>
                </FormGroup>
            </Form>
        );
    }
}
